'use strict';
// noinspection ES6UnusedImports -> is necessary for "$spinner.spritespin({..." to work
import spritespin from 'spritespin';

class ItemDetailPhoto {
	init() {
		//Disabled contextmenu in lot pages
		$('.lot, .zoomLens').on('contextmenu', function (e) {
			e.preventDefault();
		});

		const $spinner = $('#instrumentSpinner');
		const isVisible = !$spinner.hasClass('d-none');

		if ($spinner.length && isVisible) {
			this.run($spinner);
		}
	}

	run($spinner) {
		// --- Define all jQuery selectors upfront ---
		const $spinRange = $('#spinRange');
		const $zoomFull = $('#zoomFullScreen');
		const $zoomFit = $('#zoomFitToScreen');
		const $togglePlay = $('#togglePlaySpinner');
		const $prevFrame = $('#prevFrame');
		const $nextFrame = $('#nextFrame');

		const photos = $spinner.data('photos');

		if (!photos || !photos.thumbs || photos.thumbs.length === 0) {
			console.error('SpriteSpin Error: No photos found to display.');
			$spinner.parent().hide(); // Hide the spinner container if there are no images
			return;
		}

		// Create a temporary image to get the dimensions of the sprite images
		const firstImage = new Image();

		firstImage.onload = () => {
			const maxWidth = 520; // Set the maximum width for the gallery
			const maxHeight = 583; // Set the maximum height for the gallery
			const naturalWidth = firstImage.naturalWidth;
			const naturalHeight = firstImage.naturalHeight;

			let displayWidth = naturalWidth;
			let displayHeight = naturalHeight;

			// Check if the image exceeds either the max width or max height
			if (naturalWidth > maxWidth || naturalHeight > maxHeight) {
				const widthRatio = maxWidth / naturalWidth;
				const heightRatio = maxHeight / naturalHeight;

				// Use the smaller ratio to ensure the image fits within both dimensions
				const ratio = Math.min(widthRatio, heightRatio);

				displayWidth = Math.round(naturalWidth * ratio);
				displayHeight = Math.round(naturalHeight * ratio);
			}

			$spinner.spritespin({
				source: photos.thumbs,
				width: displayWidth,
				height: displayHeight,
				frame: 0,
				animate: false,
				plugins: ['progress', '360', 'drag'],
			});

			const api = $spinner.spritespin('api');

			// Handler for frame changes to update controls
			const onFrameChange = () => {
				const currentFrame = api.currentFrame();
				$spinRange.val(currentFrame);

				if (photos.zooms && photos.zooms[currentFrame]) {
					const currentZoomImage = photos.zooms[currentFrame];
					$zoomFull.attr('href', currentZoomImage);
					$zoomFit.attr('href', currentZoomImage);
				}
			};

			// Bind the event handler to the spritespin instance
			$spinner.on('onFrameChanged.spritespin', onFrameChange);

			// Manually call once to set the initial state for the zoom links and range input
			onFrameChange();

			// --- Setup Event Listeners ---
			$spinRange.on('input', function () {
				api.updateFrame(Number($(this).val()));

				if (api.data.loop) {
					$(this).val(api.currentFrame());
				}
			});

			$togglePlay.on('click', (e) => {
				api.data.loop = true;
				api.data.frameTime = 100;
				api.toggleAnimation();
				$(e.currentTarget).children().toggleClass('fa-play fa-stop');
			});

			$prevFrame.on('click', () => api.prevFrame());
			$nextFrame.on('click', () => api.nextFrame());
		};

		firstImage.onerror = () => {
			console.error('SpriteSpin Error: Could not load the first image to determine dimensions.');
			$spinner.parent().hide(); // Hide on error
		};

		// Set the image source to trigger the onload/onerror events
		firstImage.src = photos.thumbs[0];
	}

	show() {
		$('.spin-photo').removeClass('d-none');
		$('.photo-nav').removeClass('d-none');
		$('.load-360').addClass('d-none');
		$('.single-photo').addClass('d-none');
	}
}

let itemDetailPhoto = new ItemDetailPhoto();
module.exports = itemDetailPhoto;
